import { useQuery } from "@tanstack/react-query";
import ApiClient from "../../../api/ApiClient";
import { Option } from "../data/Option";

async function get(categoryId: number | undefined): Promise<Option[]> {
    const response = await ApiClient({ url: `categories/${categoryId}/options`, method: "GET" });

    if (response.status === 200) {
        return response.data;
    }
    throw new Error(response.data);
}

export function useGetCategoryOptionsQuery(categoryId: number | undefined) {
    return useQuery<Option[]>({
        queryKey: ["get-options"],
        queryFn: () => get(categoryId),
        refetchOnWindowFocus: false,
        enabled: !!categoryId,
    });
}